<div class="p-4">
  <!-- Stats cards -->
  @if (stats) {
    <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      <div class="stat-card">
        <p class="stat-label">{{ 'RAPPORT_PARCOURS.NOMBRE_PARCOURS' | translate }}</p>
        <p class="stat-value">{{ stats.nombreParcours }}</p>
      </div>
      <div class="stat-card">
        <p class="stat-label">{{ 'RAPPORT_PARCOURS.TOTAL_FORMATIONS' | translate }}</p>
        <p class="stat-value">{{ stats.totalFormations }}</p>
      </div>
      <div class="stat-card">
        <p class="stat-label">{{ 'RAPPORT_PARCOURS.UTILISATEURS_VISES' | translate }}</p>
        <p class="stat-value">{{ stats.utilisateursVises }}</p>
      </div>
      <div class="stat-card">
        <p class="stat-label">{{ 'RAPPORT_PARCOURS.PCT_COMPLETE_MOYEN' | translate }}</p>
        <p class="stat-value">{{ stats.pourcentageCompleteMoyen }}%</p>
      </div>
      <div class="stat-card">
        <p class="stat-label">{{ 'RAPPORT_PARCOURS.PCT_AVANCEMENT_MOYEN' | translate }}</p>
        <p class="stat-value">{{ stats.pourcentageAvancementMoyen }}%</p>
      </div>
      <div class="stat-card">
        <p class="stat-label">{{ 'RAPPORT_PARCOURS.A_REFAIRE' | translate }}</p>
        <p class="stat-value">{{ stats.utilisateursARefaire }}</p>
      </div>
    </div>
  }

  <!-- Table section -->
  <div class="table-card">
    <div class="flex justify-between items-center mb-4 flex-wrap gap-2">
      <h2 class="text-white font-semibold text-lg">{{ 'RAPPORT_PARCOURS.LISTE_PARCOURS' | translate }}</h2>
      <div class="flex gap-2">
        <button [matMenuTriggerFor]="exportMenu" [disabled]="isLoading || !dataSource.data.length" class="btn-primary-novo">
          {{ 'RAPPORT_PARCOURS.EXPORT' | translate }}
          <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #exportMenu="matMenu" panelClass="export-menu-styling">
          <button mat-menu-item (click)="exporterExcel()">
            <mat-icon>table_view</mat-icon>
            <span>{{ 'RAPPORT_PARCOURS.EXPORT_EXCEL' | translate }}</span>
          </button>
          <button mat-menu-item (click)="exporterPdf()">
            <mat-icon>picture_as_pdf</mat-icon>
            <span>{{ 'RAPPORT_PARCOURS.EXPORT_PDF' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <!-- Search -->
    <div class="report-filters mb-4">
      <input type="text" [(ngModel)]="recherche" (ngModelChange)="appliquerRecherche()"
        placeholder="{{ 'RAPPORT_PARCOURS.RECHERCHER_PARCOURS' | translate }}" class="rapport-search-input" />
        <mat-select class="filtre-select" [(ngModel)]="filtreOrganisation" (selectionChange)="appliquerFiltres()"
          multiple placeholder="{{ 'RAPPORT_PARCOURS.TOUTES_ORGANISATIONS' | translate }}" panelWidth="280">
          <mat-option>
            <ngx-mat-select-search [formControl]="organisationFilterCtrl"
              [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'USERS_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          @for (organisation of filteredOrganisations | async; track organisation) {
            <mat-option [value]="organisation">{{ organisation }}</mat-option>
          }
        </mat-select>
        <button mat-icon-button type="button" class="rapport-reset-btn" (click)="reinitialiserFiltres()">
          <mat-icon>restore</mat-icon>
        </button>
      </div>

      @if (isLoading) {
        <div class="flex justify-center items-center h-64">
          <mat-spinner color="accent"></mat-spinner>
        </div>
      }

      @if (!isLoading) {
        <mat-table [dataSource]="dataSource" matSort class="table-vue-parcours">
          <ng-container matColumnDef="nom">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'RAPPORT_PARCOURS.NOM_PARCOURS' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span>{{ row.nom }}</span>
              @if (row.estRecurrent && row.recurrenceEnAnnees) {
                <span class="ml-2 px-2 py-0.5 text-xs rounded-full bg-gray-600 text-gray-100 whitespace-nowrap">
                  {{ 'LEARNING_PATH_MANAGEMENT.RECURRENCE_BADGE' | translate: { count: row.recurrenceEnAnnees } }}
                </span>
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="nbreContenus">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'RAPPORT_PARCOURS.NBRE_CONTENUS' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.nbreContenus }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="nbreUtilisateursVises">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'RAPPORT_PARCOURS.NBRE_UTILISATEURS_VISES' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.nbreUtilisateursVises }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="pourcentageComplete">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <span class="flex items-center gap-1">
                {{ 'RAPPORT_PARCOURS.PCT_COMPLETE' | translate }}
                <mat-icon class="rapport-info-icon" [matTooltip]="'RAPPORT_PARCOURS.PCT_COMPLETE_TOOLTIP' | translate" matTooltipPosition="above">info_outline</mat-icon>
              </span>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <div class="rapport-progress-container">
                <div class="rapport-progress-bar progress-blue" [style.width.%]="row.pourcentageComplete" [class.has-value]="row.pourcentageComplete > 0"></div>
              </div>
              <span class="ml-2 text-white text-sm">{{ row.pourcentageComplete }}% ({{ row.nbreUtilisateursAyantComplete }}/{{ row.nbreUtilisateursVises }})</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="pourcentageAvancement">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <span class="flex items-center gap-1">
                {{ 'RAPPORT_PARCOURS.PCT_AVANCEMENT' | translate }}
                <mat-icon class="rapport-info-icon" [matTooltip]="'RAPPORT_PARCOURS.PCT_AVANCEMENT_TOOLTIP' | translate" matTooltipPosition="above">info_outline</mat-icon>
              </span>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <div class="rapport-progress-container">
                <div class="rapport-progress-bar progress-green" [style.width.%]="row.pourcentageAvancement" [class.has-value]="row.pourcentageAvancement > 0"></div>
              </div>
              <span class="ml-2 text-white text-sm">{{ row.pourcentageAvancement }}% ({{ row.nbreContenusCompletes }}/{{ row.nbreContenusTotal }})</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef>{{ 'RAPPORT_PARCOURS.ACTIONS' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <button mat-stroked-button class="details-btn" (click)="voirDetails.emit(row.parcoursFormationId)">
                {{ 'RAPPORT_PARCOURS.VOIR_DETAILS' | translate }} <mat-icon>chevron_right</mat-icon>
              </button>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center py-4 text-gray-400" [attr.colspan]="displayedColumns.length">
              {{ 'CONTENUS_MANAGEMENT.NO_RESULTS' | translate }}
            </td>
          </tr>
        </mat-table>
      }

      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" showFirstLastButtons></mat-paginator>
    </div>
  </div>
